import styled from 'styled-components';
import breakpoints from '../breakpoints';

const Wrapper = styled.div`
    color: #2A2A33;
    display: flex;
    flex-direction: column;
    font-family: 'Open Sans', sans-serif;
    justify-content: center;
    padding: 0 33px;
    text-align: center;

    @media ${breakpoints.large} {
        padding: 0 73px;
    }

    @media ${breakpoints.extraLarge} {
        padding: 0 140px;
    }
`;

const Body = styled.div`
    font-size: 16px;
    letter-spacing: 0;
    line-height: 22px;

    @media ${breakpoints.medium} {
        font-size: 22px;
        line-height: 30px;
    }
`;

const Byline = styled.div`
    font-size: 16px;
    font-weight: bold;
    padding-top: 20px;
`;

export default {
    Body,
    Byline,
    Wrapper,
};
